import { render, staticRenderFns } from "./WidgetList.global.vue?vue&type=template&id=23903e84&lang=pug&"
import script from "./WidgetList.global.vue?vue&type=script&lang=ts&"
export * from "./WidgetList.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports